import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedProduct: null,
  filters: {
    search: "",
    categoryId: "",
    isActive: true,
    page: 1,
    limit: 10,
  },
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setSelectedProduct, setFilters, clearFilters } =
  productsSlice.actions;
export default productsSlice.reducer;
